import React from "react";
import "./KoyoDescription.styles.scss";

const KoyoDescription = () => {
  return (
    <div className="koyo-description-div">
      <h1 className="koyo-page-heading">Koyo</h1>
      <p className="koyo-page-text">
        NOD Bearings Pvt. Ltd. is the National Distributor of Koyo in India. We
        are celebrating over 50 years working with Koyo.
      </p>
    </div>
  );
};

export default KoyoDescription;
